<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <h4 class="mb-sm-0">Discounts Management</h4>
        <div class="page-title-right">
          <ol class="breadcrumb m-0">
            <li class="breadcrumb-item"><a routerLink="/dashboard">Menu</a></li>
            <li class="breadcrumb-item active">Add Discount</li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header align-items-center d-flex">
          <h4 class="card-title mb-0 flex-grow-1">Add Discount</h4>
          <div class="flex-shrink-0">
            <a routerLink="/ecomm/discounts" class="btn btn-light me-2">Cancel</a>
            <button type="button" class="btn btn-primary" (click)="submit()">Add Discount</button>
          </div>
        </div>
        <div class="card-body">
          <div class="row gy-4">
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="discountName">Name <span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="discountName" name="name" [(ngModel)]="form.name"
                     [ngClass]="{'is-invalid': !form.name && validationTriggered, 'is-valid': validationTriggered && form.name}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="discountType">Discount Type <span class="text-danger">*</span></label>
              <select class="form-select" id="discountType" name="discount_type" [(ngModel)]="form.discount_type">
                <option [ngValue]="1">Amount</option>
                <option [ngValue]="2">Percentage</option>
              </select>
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="discountValue">Discount Value <span class="text-danger">*</span></label>
              <input type="number" step="0.01" class="form-control" id="discountValue" name="discount_value" [(ngModel)]="form.discount_value"
                     [ngClass]="{'is-invalid': (form.discount_value === '' || form.discount_value === null) && validationTriggered, 'is-valid': validationTriggered && form.discount_value !== '' && form.discount_value !== null}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="discountStatus">Status <span class="text-danger">*</span></label>
              <select class="form-select" id="discountStatus" name="status" [(ngModel)]="form.status">
                <option [ngValue]="1">Active</option>
                <option [ngValue]="2">Inactive</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
